import { RegionViewModel } from "../viewmodels/RegionViewModel.js";
import { useSingleton } from "mvc-kit/react";
// src/modules/AppWrapper2/hooks/useCurrentUserRegions.ts
function useCurrentUserRegions() {
	const regionVM = useSingleton(RegionViewModel);
	return {
		allowMultiRegionSelection: regionVM.state.allowMultiRegionSelection,
		availableRegions: regionVM.availableRegions,
		changeCurrentRegion: regionVM.changeRegion,
		currentRegion: regionVM.currentRegion,
		scopeAllRegions: regionVM.state.scopeAllRegions,
		selectedRegions: regionVM.selectedRegions,
		userPrimaryRegionId: regionVM.userPrimaryRegionId
	};
}
export { useCurrentUserRegions };

//# sourceMappingURL=useCurrentUserRegions.js.map